/* Advanced WhatsApp chat bubble — greeting popup + multi-department picker.
   Markup: [data-wa-chat] > [data-wa-greeting], [data-wa-list], [data-wa-toggle] */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-wa-chat]').forEach(function (root) {
      if (root.dataset.waReady === 'true') return;
      root.dataset.waReady = 'true';

      var toggle = root.querySelector('[data-wa-toggle]');
      var list = root.querySelector('[data-wa-list]');
      var greeting = root.querySelector('[data-wa-greeting]');
      var greetingClose = root.querySelector('[data-wa-greeting-close]');
      var greetingCta = root.querySelector('[data-wa-greeting-cta]');
      var isMulti = root.dataset.multi === 'true';
      var sessionKey = 'wa-chat-greeting-dismissed';

      function openDirect() {
        if (toggle && toggle.dataset.waHref) window.open(toggle.dataset.waHref, '_blank', 'noopener');
      }

      function hideGreeting(remember) {
        if (!greeting) return;
        greeting.classList.remove('is-open');
        if (remember) {
          try { sessionStorage.setItem(sessionKey, '1'); } catch (e) {}
        }
      }

      function showGreeting() {
        if (!greeting) return;
        var once = root.dataset.greetingOnce === 'true';
        if (once) {
          try {
            if (sessionStorage.getItem(sessionKey) === '1') return;
          } catch (e) {}
        }
        greeting.classList.add('is-open');
      }

      var delay = parseFloat(root.dataset.greetingDelay || '0');
      if (greeting && delay >= 0) {
        setTimeout(showGreeting, delay * 1000);
      }

      if (greetingClose) {
        greetingClose.addEventListener('click', function () { hideGreeting(true); });
      }

      if (greetingCta) {
        greetingCta.addEventListener('click', function () {
          hideGreeting(true);
          if (isMulti && list) {
            list.classList.add('is-open');
          } else {
            openDirect();
          }
        });
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          hideGreeting(true);
          if (isMulti && list) {
            list.classList.toggle('is-open');
          } else {
            openDirect();
          }
        });
      }

      document.addEventListener('click', function (e) {
        if (!isMulti || !list || !list.classList.contains('is-open')) return;
        if (!e.target.closest('[data-wa-chat]')) list.classList.remove('is-open');
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', init);
})();
